import cx from 'classnames';
import React from 'react';
import * as marvelURL from '../constants/marvelURL';
import styles from './MadeWithMarvel.module.css';
export default function MadeWithMarvel() {
    return (React.createElement("a", { className: cx(styles.madeWithMarvel, 'zi-500'), href: marvelURL.HOMEPAGE, target: "_parent" }, "Made with Marvel"));
}
